import React from 'react'
import '../Styles/gallery.css'

import foto1 from "../Assets/bolsas biodegradables/funda.jpg"
import foto2 from "../Assets/bolsas biodegradables/funda2.jpg"
import foto3 from "../Assets/bolsas biodegradables/funda3.jpg"
import foto4 from "../Assets/bolsas biodegradables/funda4.jpg"


const Gallery = () => {
    return (
        <div className="gal">
            <h1 className="titulo">FUNDAS BIODEGRADABLES</h1>
            <div className="galeria" id="FUNDAS">
                <a href="#imagenf1">
                    <img src={foto1} alt=""/>
                </a>
                <a href="#imagenf2">
                    <img src={foto2} alt=""/>
                </a>
                <a href="#imagenf3">
                    <img src={foto3} alt=""/>
                </a>
                <a href="#imagenf4">
                    <img src={foto4} alt=""/>
                </a>
            </div>

            <div className="light-box" id="imagenf1">  
                <a href="#imagenf5" className="next">
                    <i className="fas fa-arrow-left"></i>
                </a>
                <img src={foto1} alt=""/>
                <a href="#imagenf2" className="next">
                    <i className="fas fa-arrow-right"></i>
                </a>
                <a href="#GALERIA" className="close" >
                    X 
                </a>
            </div>

            <div className="light-box" id="imagenf2">  
                <a href="#imagenf1" className="next">
                    <i className="fas fa-arrow-left"></i>
                </a>
                <img src={foto2} alt=""/>
                <a href="#imagenf3" className="next">
                    <i className="fas fa-arrow-right"></i>
                </a>
                <a href="#GALERIA" className="close">
                    X
                </a>
            </div>

            <div className="light-box" id="imagenf3">  
                <a href="#imagenf2" className="next">
                    <i className="fas fa-arrow-left"></i>
                </a>
                <img src={foto3} alt=""/>
                <a href="#imagenf4" className="next">
                    <i className="fas fa-arrow-right"></i>
                </a>
                <a href="#GALERIA" className="close">
                    X
                </a>
            </div>

            <div className="light-box" id="imagenf4">  
                <a href="#imagenf3" className="next">
                    <i className="fas fa-arrow-left"></i>
                </a>
                <img src={foto4} alt=""/>
                <a href="#imagenf1" className="next">
                    <i className="fas fa-arrow-right"></i>
                </a>
                <a href="#GALERIA" className="close">
                    X
                </a>
            </div>


        </div>
    )
}

export default Gallery
